import React from "react";
import { CorpDetailAPIEntity } from "../serviceoperation/entity/CorporationOperationEntity";

export interface ICompanyContext {
  companyData: Array<CorpDetailAPIEntity>;
  selectedCompany?: CorpDetailAPIEntity;
  isCompanyDataLoading: boolean;
  updateSelectedCompany: (
    companyId: number,
    companyOverride?: CorpDetailAPIEntity,
  ) => void;
}

export const CompanyContext = React.createContext<ICompanyContext>({
  companyData: [],
  isCompanyDataLoading: false,
  updateSelectedCompany: () => {
    return;
  },
});
